import { Swiper, Navigation, Pagination } from 'swiper/dist/js/swiper.esm.js';
Swiper.use([Navigation, Pagination]);
import ServiceLocator from "../../global/service-locator";

export default class FeedbackSection {
    constructor() {
        this.$section = document.getElementById('feedbackSection');
        this.$modal = document.getElementById('modal-feedback');
        this.$showMore = document.getElementById('feedbackShowMore');
        this.$feedbackCards = null;
        this.$slides = null;
        this.$socials = null;

        this.sl = ServiceLocator.instance;

        this.sliderConfig = null;
        this.swiper = null;

        this.init();
    }

    init() {
        if (this.$section == null) {
            return;
        }

        this.$feedbackCards = this.$section.querySelectorAll('.feedback-card');
        this.$slides = this.$modal.querySelectorAll('.swiper-slide');
        this.$socials = this.$section.querySelectorAll('.feedback-user-social');

        this.sliderConfig = {
            navigation: {
                nextEl: '.swiper-slider-next',
                prevEl: '.swiper-slider-prev',
            },
            slidesPerView: 1,
            slidesPerGroup: 1,
            loop: this.$slides.length > 1,
            autoHeight: true,
            on: {
                init: function () {
                    setTimeout(() => {
                        this.updateAutoHeight(250);
                    }, 50);
                    lozadObserver.observe();
                },
            }
        };

        this.sl.modalService.register('feedback', Array.from(this.$feedbackCards), {
            withCloseBtn: true,
            beforeOpen: ($trigger) => {
                setTimeout(() => {
                    if (this.swiper == null) {
                        this.swiper = new Swiper(`#feedbackSlider`, this.sliderConfig);
                    }

                    const id = $trigger.dataset.id;
                    const $slide = Array.from(this.$slides).find(($slide) => $slide.firstElementChild.dataset.id === id);

                    if ($slide != null) {
                        const slideToIndex = +$slide.dataset.swiperSlideIndex + 1;
                        this.swiper.slideTo(slideToIndex, 0);
                    }
                }, 0);
            }
        });

        this.$socials.forEach(($social) => {
            $social.addEventListener('click', (e) => e.stopPropagation());
        });

        this.$showMore.addEventListener('click', () => {
            const $feedbackList = this.$section.querySelector('.feedback-list');

            if ($feedbackList) {
                $feedbackList.classList.add('-show-more');
                this.$showMore.remove();
            }
        });
    }
}